import { createRouter, createWebHistory } from 'vue-router';

import { useAuthStore } from '@/store/authStore';
import { RouteNames, routes } from '@/router/routes';
import { logoutAndResetAllStoresWithCid } from '@/store/storeUtils';

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from) => {
  const authStore = useAuthStore();
  if (typeof to.meta.title === 'string') {
    document.title = to.meta.title || 'YAPEAL';
  }

  const authRequired = to.meta.requiresAuth;
  const loggedIn = authStore.checkIsAuthenticated();

  if (authRequired && !loggedIn) {
    logoutAndResetAllStoresWithCid();
    return { name: RouteNames.Login };
  }

  if (loggedIn && to.name === RouteNames.Login) {
    return { name: RouteNames.Dashboard };
  }

  /**
   * Redirect any unknown routes to transactions (until we have a proper 404 page)
   * If the route has no name, it is an unknown page
   */
  //
  if (loggedIn && !to.name) {
    return { name: RouteNames.Dashboard };
  }
});

export default router;
